import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MenuProvider {

  private onChange$ = new Subject<boolean>();

  constructor() { }

  onChange(): Observable<boolean> {
    return this.onChange$.asObservable();
  }

  setStatus(isOpen: boolean): void {
    this.onChange$.next(isOpen);
  }

}



// WEBPACK FOOTER //
// ./src/providers/menu/menu.ts